module.exports = __webpack_public_path__ + "imgs/fox_logo.13a4ceb1.png";